<template>
  <div>
    <!-- 個人資料 -->
    <div class="card">
      <div v-if="loginUser != null" class="card-body box-profile">
        <div class="text-center">
          <avatarVue :src="loginUser.userLogoBig" :size="100"></avatarVue>
          <!-- <el-avatar :src="loginUser.userLogoBig" :size="100"></el-avatar> -->
        </div>
        <h3 class="profile-username text-center mb-1">
          {{ userData.sgL_MyVideoName == '' || userData.sgL_MyVideoName == null ? loginUser.displayName :
            loginUser.displayName + '(' + userData.sgL_MyVideoName + ')' }}
        </h3>
        			  <div class="reward_center mt-2 mb-2">
                  <!-- 獎牌名單列表 -->
  				<div class="toooltip" v-for="(item,idx) in medalListData">
  					<img :src="item.sgL_URL" style="width:40px;">
  					<span class="toooltiptext">{{ item.sgL_Title  }}<br/> 
  						<span class="exchange_point b-operate-btn" type="button" @click="showExchangePoint(item.id)">兌換為點數</span>
  					</span>
  				</div>
  			  </div>  
           <p class="text-center mb-1">現有點數：{{ Runningwater.sgL_AfterPoint ? Runningwater.sgL_AfterPoint : 0 }}</p>
        <p class="text-muted text-center">{{ loginUser.sgL_Myself }}</p>
      </div>
      <div v-else>
        <div class="card-body box-profile">
          <div class="text-center">
            <avatarVue :src="defaultLog" :size="100"></avatarVue>
            <!-- <el-avatar
              src="https://api.soonnet.org/Userlogo_Smail.jpg"
              :size="100"
            ></el-avatar> -->
          </div>
          <h3 class="profile-username text-center mb-1 nologin">
            <a href="javascript:void(0);" @click="login"> {{ $t('Social.UserFeedInfo.login') }}</a>
          </h3>
        </div>
      </div>
      <!-- /.card-body -->
      <div class="card-body">
        <ul>
          <li class="profile-nav" v-if="customers">
            <router-link :to="{ name: 'customerPublishLook', query: { 'authorId': customers.userId } }">
            <i class="fas fa-user-circle fa-fw mr-1" /> {{ $t('Customer.customerPublish.Homepage') }}
            </router-link>
          </li>

          <profileNavItemVue :isActive="props_selectItem == 'feed'" @ck="changeSelectItem('feed')">
            <template v-slot:icon>
              <i class="fas fa-home fa-fw mr-1"></i>
            </template>
            <template v-slot:txt> {{ $t('Social.UserFeedInfo.home') }} </template>
          </profileNavItemVue>
          <profileNavItemVue :isActive="props_selectItem == 'FeedCloud'" @ck="changeSelectItem('FeedCloud')">
            <template v-slot:icon>
              <i class="fas fa-video fa-fw mr-1"></i>
            </template>
            <template v-slot:txt> {{ $t('Social.UserFeedInfo.video') }} </template>
          </profileNavItemVue>

                    <profileNavItemVue :isActive="props_selectItem == 'pointRecond'" @ck="changeSelectItem('pointRecond')">
              <template v-slot:icon>
                <i class="fas fa-medal fa-fw mr-1"></i>
              </template>
              <template v-slot:txt> 我的點數記錄 </template>
            </profileNavItemVue>

          <profileNavItemVue :isActive="props_selectItem == 'group'" @ck="changeSelectItem('feedGroup')">
            <template v-slot:icon>
              <i class="fas fa-users fa-fw mr-1"></i>
            </template>
            <template v-slot:txt> {{ $t('Social.UserFeedInfo.group') }} </template>
          </profileNavItemVue>

          <profileNavItemVue :isActive="props_selectItem == 'friend'" @ck="changeSelectItem('feedfriend')">
            <template v-slot:icon>
             <i class="fas fa-user-friends fa-fw mr-1" />
            </template>
            <template v-slot:txt> {{ $t('Social.UserFeedInfo.user') }} </template>
          </profileNavItemVue>

          <profileNavItemVue :isActive="props_selectItem == 'customerPrivateMessage'"
            @ck="changeSelectItem('customerPrivateMessage')">
            <template v-slot:icon>
              <i class="fas fa-comments fa-fw mr-1"></i>
            </template>
            <template v-slot:txt> {{ $t('Social.UserFeedInfo.comments') }} </template>
          </profileNavItemVue>
          <!-- <profileNavItemVue
            :isActive="props_selectItem == 'MyDynamic'"
            @ck="changeSelectItem('MyDynamic')"
          >
            <template v-slot:icon>
              <i class="fas fa-user-circle fa-fw mr-1"></i>
            </template>
            <template v-slot:txt> 我的動態 </template>
          </profileNavItemVue>
          <profileNavItemVue
            :isActive="props_selectItem == 'MyDynamicPic'"
            @ck="changeSelectItem('MyDynamicPic')"
          >
            <template v-slot:icon>
              <i class="fas fa-user-circle fa-fw mr-1"></i>
            </template>
            <template v-slot:txt> 我發布的內容 </template>
          </profileNavItemVue> -->
        </ul>
      </div>
      <!-- /.card-body -->
    </div>
    <!-- /.card -->
    <!-- /.個人資料 -->
  <medalView ref="medalView" @onMedalSubmit="GetEventMedalsByUser"></medalView>
  </div>
</template>

<script>
import profileNavItemVue from "../common/profileNavItem.vue";
import avatarVue from "../common/avatar.vue";
import medalView from "./medalView.vue";
export default {
  data () {
    return {
      defaultLog: "https://api.soonnet.org/Userlogo_Smail.jpg",
      selectItem: this.props_selectItem,
      userData: {},
      medalListData: [],
            Runningwater: {},
    };
  },
  props: {
    props_selectItem: { Type: String, default: "feed", required: false },
  },
  components: { profileNavItemVue, avatarVue, medalView },
  computed: {
    customers () {
      return this.$store.getters.getcustomer;
    },
  },
  created () {
    // console.log(this.loginUser);
    this.getuserData();
    this.GetEventMedalsByUser();
    this.SystemActivityFirst();
  },
  methods: {
    login () {
      this.CheckUserIsLogin();
    },
    changeSelectItem (item) {
      this.$emit("changeSelectItem", item);
      this.$router.push({
        name: item,
      });
    },
    async getuserData () {
      const { data: { result } } = await this.$api.common.getCustomerModel({ 'id': this.loginUser.userId });
      this.userData = result;
    },
    async showExchangePoint(Id){
      this.$refs.medalView.setData(Id);
    },
    ExchangePoint(){},
    async GetEventMedalsByUser(){
      // this.loginUser.userId
      const { data: { result } } = await this.$api.common.GetEventMedalsByUser({ 'usersId': this.loginUser.userId });
      this.medalListData = result;
    },
       async SystemActivityFirst () {
      const params = {};
      const { data: result } = await this.$api.medalApi.SystemActivityFirst(params);
      if (!result.success) {
        result.error.code !== 500 && this.$message.error(result.error.message);
        return;
      }
      this.Runningwater = result.result ? result.result : {};
    },
  },
};
</script>

<style scoped>
.nologin {
  font-size: 1em;
}

</style>


// WEBPACK FOOTER //
// src/components/Social/UserFeedInfo.vue